import { matchers, traverse } from '@sail/rpc';
const encoder = {
    encode: (data)=>traverse(data, [
            matchers.error.encode,
            // We don't want to send functions over the wire (ex _internal_observability),
            // so we just return 'undefined'.
            [
                (data)=>typeof data === 'function',
                ()=>undefined
            ]
        ]),
    decode: (data)=>traverse(data, [
            matchers.error.decode
        ])
};
export default encoder;

//# sourceMappingURL=encoder.js.map